
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useLogicFlows } from '@/hooks/useLogicFlows';

interface LogicSidebarProps {
  onSave: () => void;
}

export default function LogicSidebar({ onSave }: LogicSidebarProps) {
  const { loadFlows, clearFlow } = useLogicFlows();

  const onDragStart = (event: React.DragEvent<HTMLDivElement>, nodeType: string) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="w-64 border-r p-3 h-full bg-muted/20">
      <h3 className="font-semibold mb-3">Node Types</h3>
      
      <div className="space-y-2">
        <Card className="cursor-grab" onDragStart={(event) => onDragStart(event, 'start')} draggable>
          <CardContent className="p-3 text-center bg-green-50 border-green-500">
            Start
          </CardContent>
        </Card>
        
        <Card className="cursor-grab" onDragStart={(event) => onDragStart(event, 'condition')} draggable>
          <CardContent className="p-3 text-center bg-blue-50 border-blue-500">
            Condition
          </CardContent>
        </Card>
        
        <Card className="cursor-grab" onDragStart={(event) => onDragStart(event, 'action')} draggable>
          <CardContent className="p-3 text-center bg-purple-50 border-purple-500">
            Action
          </CardContent>
        </Card>
        
        <Card className="cursor-grab" onDragStart={(event) => onDragStart(event, 'end')} draggable>
          <CardContent className="p-3 text-center bg-red-50 border-red-500">
            End
          </CardContent>
        </Card>
      </div>

      <div className="mt-6">
        <h3 className="font-semibold mb-3">Flow Controls</h3>
        <div className="space-y-2">
          <Button variant="outline" className="w-full" onClick={onSave}>Save Flow</Button>
          <Button variant="outline" className="w-full" onClick={loadFlows}>Load Flow</Button>
          <Button variant="outline" className="w-full" onClick={clearFlow}>Clear</Button>
        </div>
      </div>
    </div>
  );
}
